import { effect, inject, Injectable, signal, untracked } from '@angular/core';
import {
  FlightResearchResponse,
  FlightSearchResponse,
} from '../../models/flight-search-response';
import { Airport } from '../../models/search-airport';
import { FilterObject } from '../../models/filter-object';
import { SelectedUpselling } from '../../models/flight';
import { Currency } from '../../models/currency';
import { SearchFilterObject } from '../../models/search-filter-object';
import { FlightDetailsResponse } from '../../models/flight-details';
import { UpsellingRequest } from '../../models/upselling-request';
import { SortType } from '../../types/sort-type';

@Injectable({
  providedIn: 'root',
})
export class FlightState {
  searchCriteria = signal<null | any>(
    sessionStorage.getItem('searchCriteria')
      ? JSON.parse(sessionStorage.getItem('searchCriteria')!)
      : null
  );

  upsellingCriteria = signal<null | any>(
    sessionStorage.getItem('upsellingCriteria')
      ? JSON.parse(sessionStorage.getItem('upsellingCriteria')!)
      : null
  );

  airports = signal<Airport[]>([]);

  //response
  flightResponse = signal<FlightResearchResponse | null>(
    sessionStorage.getItem('flightResponse')
      ? JSON.parse(sessionStorage.getItem('flightResponse')!)
      : null
  );
  flightDetailsResponse = signal<FlightDetailsResponse | null>(null);
  upsellingResponses = signal<Record<string, FlightSearchResponse>>({});

  // loading
  flightSearchLoading = signal(false);
  flightReSearchLoading = signal(false);
  flightDetailsLoading = signal(false);
  upsellingLoading = signal(false);
  firstStepLoading = signal(false);
  secondStepLoading = signal(false)
  travelExtraLoading = signal(false);

  //error
  upsellingError = signal(false);
  flightError = signal(false);
  // the progressive search (research polling) failed: the flights found so far stay, with "Search again"
  flightSearchError = signal(false);

  selectedUpselling = signal<SelectedUpselling | null>(null);
  isSeletedUpselling = signal(false);

  flightResponseSearchId = signal<string | null>(
    sessionStorage.getItem('flightSearchId') || null
  );
  confirmPriceSearchId = signal<string | null>(null);

  travelExtraRequest = signal<UpsellingRequest | null>(null);
  flightFilters = signal<FilterObject | null>(null);
  savedFilters = signal<SearchFilterObject | null>(null);
  currentPage = signal(1);
  sortType = signal<SortType>('BEST_PRICE');
  /** stops chosen in the results-page search: applied as the Stops filter once the new search answers */
  pendingStops = signal<number[] | null>(null);
  /** the filters of a search run again (Search again, Refresh results): applied once the new search answers */
  pendingFilters = signal<SearchFilterObject | null>(null);

  currency = signal<Currency | null>(null);
  orderItems = signal<any | null>(null);

  //////////////////////////////////////////////////////////////////////////////////////////////

  setflightResponse(response: FlightResearchResponse) {
    this.flightResponse.set(response);
    sessionStorage.setItem('flightResponse', JSON.stringify(response));
  }

  removeflightResponse() {
    this.flightResponse.set(null);
    sessionStorage.removeItem('flightResponse');
  }

  updateTravelExtra(changes: Partial<UpsellingRequest>) {
    const current = this.travelExtraRequest()!;

    this.travelExtraRequest.set({
      ...current,
      ...changes,
    });
  }
}
